import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Reusable banner displayed on Master entry screens after submitting
 * a record for approval to the central queue.
 */
export default function MasterApprovalBanner({
  pendingApproval,
  queueRoute = '/approval/masters/list',
  className = '',
}) {
  if (!pendingApproval) return null

  return (
    <div className={`rounded-2xl border border-primary/30 bg-primary/10 p-5 text-sm text-on-surface ${className}`}>
      <div className="flex items-center gap-3">
        <span className="material-symbols-outlined text-primary text-2xl">hourglass_top</span>
        <div className="flex-1">
          <span className="font-bold block text-primary">
            Submitted for Approval (Request #{pendingApproval.requestId})
          </span>
          <span className="text-xs text-on-surface-variant">{pendingApproval.message}</span>
        </div>
        <Link
          to={queueRoute}
          className="rounded-xl bg-primary text-on-primary px-4 py-2 text-xs font-bold hover:bg-primary/90 transition shadow-sm shrink-0"
        >
          Go to Approval Queue
        </Link>
      </div>
    </div>
  )
}
